import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ScreenNotificationDefault} from '../../components';
import {preAvaliacaoSolicitar} from '../../ducks/Customer';
import {ClipLoader} from 'react-spinners';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class ProcessingPreEvaluation extends Component {
  async componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.ProcessingPreEvaluation.title,
    );

    if (!this.props.realizouPreAvaliacao) {
      let chave = this.props.chave;
      this.props.preAvaliacaoSolicitar({chave});
    }
  }

  render() {
    const {backgroundPrimario} = this.props.primario;
    return (
      <ScreenNotificationDefault
        title={<p>Análise do Pedido</p>}
        contentCustom={
          <div className="loading-pre-evaluation">
            <ClipLoader sizeUnit={'px'} size={150} color={backgroundPrimario} />

            <p>Aguarde alguns segundos estamos analisando o seu pedido</p>
          </div>
        }
        contentButtons={<div className="div-data-contact"></div>}
      />
    );
  }
}

const mapStateToProps = ({customer, theme}) => {
  const {chave, realizouPreAvaliacao} = customer;
  const {primario} = theme;
  return {chave, primario, realizouPreAvaliacao};
};
export default connect(mapStateToProps, {preAvaliacaoSolicitar})(
  ProcessingPreEvaluation,
);
